import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['select', 'panel']

  connect() {
    this.showActivePanel()
  }

  change() {
    this.showActivePanel()
  }

  // private

  showActivePanel() {
    const selectedType = this.selectTarget.value

    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.type === selectedType
      panel.hidden = !isActive

      panel.querySelectorAll('input, select, textarea').forEach(input => {
        input.disabled = !isActive
      })
    })
  }
}
